<template>
  <div class="offcn-teacher-open">
    <p class="offcn-live-lineone"><img src="./livedownload.png">中公直播</p>
    <p class="offcn-live-linetwo">如果您已安装中公直播教师客户端，可点击启 动进行直播。</p>
    <button class="offcn-live-client" @click='openclient'>打开客户端</button>
    <p class="offcn-live-linethree">如果您首次使用中公直播，请先下载客户端并在电脑上安装。</p>
    <button class="offcn-live-download" @click='downclient'>下载客户端</button>
    <p class="offcn-live-serviceline">登录遇到问题请联系： <span class="offcn-live-telephone">400-900-8885</span></p>
  </div>
</template>

<script>
export default {
  methods: {
  	openclient () {
  		window.location.href = 'zglive://nickname=' + this.$route.query.nickname + '&password=' + this.$route.query.password
  	},
  	downclient () {
  		window.open('http://desktop.offcncloud.com/updatePackage/ZgLiveSetup.exe')
  	}
  },
  mounted () {
  	if (!this.$route.query.nickname) {
  		this.$router.push({path: 'login', query: {password: this.$route.query.password}})
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offcn-teacher-open
{
	margin-left: 358px;
}
.offcn-live-lineone
{
	display: flex;
	align-items: center;
	font-size: 36px;
	padding-top: 80px;
	font-weight: 600;
	img
	{
		margin-right: 16px;
	}
}
.offcn-live-linetwo
{
	margin-top: 80px;
	font-size: 22px;
}
.offcn-live-client,.offcn-live-download
{
	width: 200px;
	height: 48px;
	font-size: 20px;
	background-color: #ff895f;
	color: white;
	border-width: 0;
	border-radius: 4px;
	margin-top: 24px;
	outline: none;
	cursor: pointer;
	font-weight: 600;
}
.offcn-live-linethree
{
	margin-top: 58px;
	font-size: 22px;
}
.offcn-live-serviceline
{
	position: absolute;
	bottom: 40px;
	font-size: 14px;
	color: #737885;
}
.offcn-live-telephone
{
	color: #ff895f;
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-download/download.vue